import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface RecentSearch {
    [key: string]: any;
}
interface SearchState {
    recentSearches: RecentSearch[],
    trendingSearches: string[],
    addRecentSearches: any,
    deleteRecentSearches: any
    keyValueStore: Record<string, any>;
    latestSearch: string | null;
}

const initialState: SearchState = {
    recentSearches: [],
    trendingSearches: [],
    addRecentSearches: [],
    deleteRecentSearches: [],
    keyValueStore: {},
    latestSearch: null
};

const searchSlice = createSlice({
    name: "searches",
    initialState,
    reducers: {
        updateRecentSearches: (state: SearchState, action: PayloadAction<{ value: RecentSearch[] }>) => {
            state.recentSearches = action.payload.value;
        },
        updateTrendingSearches: (state: SearchState, action: PayloadAction<{ value: string[] }>) => {
            state.trendingSearches = action.payload.value;
        },
        updateAddRecentSearches: (state: SearchState, action: PayloadAction<{ value: RecentSearch }>) => {
            state.recentSearches.push(action.payload.value);
        },
        updateDeleteRecentSearches: (state: SearchState, action: PayloadAction<{ value: string }>) => {
            try {
                state.recentSearches = state.recentSearches.filter(
                    (search: any) => search.title !== action.payload.value
                );
            } catch (err) {
                console.error('[ERROR::]', err);
            }
        },
        addKeyValuePair: (
            state: SearchState,
            action: PayloadAction<{ key: string; value: any }>
        ) => {
            state.keyValueStore[action.payload.key] = action.payload.value;
        },
        updateLatestSearch: (state: SearchState, action: PayloadAction<{ value: string }>) => {
            state.latestSearch = action.payload.value;
        },
    },
});

// Export actions and reducer
export const { updateRecentSearches, updateTrendingSearches, updateAddRecentSearches, updateDeleteRecentSearches, addKeyValuePair, updateLatestSearch } = searchSlice.actions;
export default searchSlice.reducer;

